exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".menu-flyout{margin:0;width:100%;position:absolute;display:flex;align-items:center;justify-content:center;z-index:4;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.375s;transition-property:top}.menu-flyout-active{top:15px}.menu-flyout-inactive{top:-70px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js?outputStyle=expanded!./src/styles/Menu.scss
// module id = 327
// module chunks = 0